import React, { useEffect, useRef, useState } from "react";

export const EndPageText = () => {
  const end_page_title = window.end_page.end_page_title;
  const end_page_description = window.end_page.end_page_description;

  const [fontClass, setFontClass] = useState(false);

  let textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const paragraphElement = textRef.current.querySelector("p");
      if (paragraphElement) {
        const length = paragraphElement.textContent.length;

        if (length > 900) {
          setFontClass(true);
        } else {
          setFontClass(false);
        }
      }
    }
  });

  return (
    <div className="text-wrapper">
      <div className="title-wrapper">
        <span>{end_page_title}</span>
      </div>
      <div
        className={`content-wrapper ${fontClass ? "high" : ""}`}
        dangerouslySetInnerHTML={{ __html: end_page_description }}
        ref={textRef}
      />
      <div />
    </div>
  );
};
